exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip-dialog[data-v-1b36ea4c]{width:100%;height:100%;position:relative}.tip-dialog__mask[data-v-1b36ea4c]{width:100%;height:100%;background-color:rgba(0,0,0,.4);position:absolute;top:-1px;left:0}.tip-dialog__box[data-v-1b36ea4c]{position:absolute;top:42%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
